export const privacyPolicyHtml = `<!doctype html>
<html xmlns:og="http://opengraphprotocol.org/schema/" xmlns:fb="http://www.facebook.com/2008/fbml" lang="en-US">
  <head>
    <meta http-equiv="X-UA-Compatible" content="IE=edge,chrome=1" />
    <meta name="viewport" content="width=device-width, initial-scale=1" />
    <!-- This is Squarespace. -->
    <!-- lobster-reed-cf94 -->
    <base href="" />
    <meta charset="utf-8" />
    <title>Privacy Policy &mdash; REFORM IS COMING</title>
    <meta http-equiv="Accept-CH" content="Sec-CH-UA-Platform-Version, Sec-CH-UA-Model" />
    <link rel="icon" type="image/x-icon" href="https://assets.squarespace.com/universal/default-favicon.ico" />
    <link rel="canonical" href="https://www.thereligionbusiness.com/privacy-policy" />
    <meta property="og:site_name" content="REFORM IS COMING" />
    <meta property="og:title" content="Privacy Policy &mdash; REFORM IS COMING" />
    <meta property="og:url" content="https://www.thereligionbusiness.com/privacy-policy" />
    <meta property="og:type" content="website" />
    <meta itemprop="name" content="Privacy Policy — REFORM IS COMING" />
    <meta itemprop="url" content="https://www.thereligionbusiness.com/privacy-policy" />
    <meta name="twitter:title" content="Privacy Policy — REFORM IS COMING" />
    <meta name="twitter:url" content="https://www.thereligionbusiness.com/privacy-policy" />
    <meta name="twitter:card" content="summary" />
    <meta name="description" content="" />
    <link rel="preconnect" href="https://images.squarespace-cdn.com" />
    <link rel="preconnect" href="https://use.typekit.net" crossorigin />
    <link rel="preconnect" href="https://p.typekit.net" crossorigin />
    <script
      type="text/javascript"
      src="//use.typekit.net/ik/Fy1TlTaDmRSu3rJ9sNtAdFq2ud8XzqFf8ipLPlRMi8qfe7SIfFHN4UJLFRbh52jhWDjuwQBywcFKwABy5AZKFAJXFRMhwRjtjs7LMkG0jAFu-WsoShFGZAsude80ZkoRdhXCHKoyjamTiY8Djhy8ZYmC-Ao1Oco8if37OcBDOcu8OfG0deNKSas8SKukZAmqOAFc5Qb0SaBujW48Sagyjh90jhNlOfG0SaBujW48SagyjhmDjhy8ZYmC-Ao1OcFzdPUyjamTiY8Djhy8ZYmC-Ao1OcFzdPUyjamTiY8Djhy8ZYmC-Ao1Oco8ifUySkolZPUCdh4DiemkOW48ZAbljhjoFfoDSWmyScmDSeBRZPoRdhXCdeNRjAUGdaFXOYFUiABkZWF3jAF8ShFGZAsude80ZkoRdhXCiey8ScmC-AiTdhoKiWFTdcmDSkoRdhXCiaiaOcBRiA8XpWFR-emqiAUTdcS0jhNlOYiaikoyjamTiY8Djhy8ZYmC-Ao1Oco8ifUaiaS0jWw0dA9CiaiaOcUzj1FXZWJlScm8ZfuRZRqXO1FUiABkZWF3jAF8OcFzdPUaiaS0SaBujW48SagyjhmDjhy8ZYmC-Ao1OcFzdPUaiaS0iey8ScmC-AiTdhoKiWFTdcmDSkoRdhXK2hyydY8yScblZe8DSeUypPGHf5P5MyMMeMJ6MKGHf5A5MyMMeMw6MKGHf5h5MyMMeMS6MKGHf555MyMMeM36MKGHf5-5MyMMeMX6MKGHf5E5MyMMegI6MTMg7HaP7Mj.js"></script>
    <script type="text/javascript">
      try {
        Typekit.load();
      } catch (e) {}
    </script>
    <script
      type="text/javascript"
      crossorigin="anonymous"
      defer="true"
      nomodule="nomodule"
      src="//assets.squarespace.com/@sqs/polyfiller/1.6/legacy.js"></script>
    <script
      type="text/javascript"
      crossorigin="anonymous"
      defer="true"
      src="//assets.squarespace.com/@sqs/polyfiller/1.6/modern.js"></script>
    <script type="text/javascript">
      SQUARESPACE_ROLLUPS = {};
    </script>
    <script>
      (function (rollups, name) {
        if (!rollups[name]) {
          rollups[name] = {};
        }
        rollups[name].js = [
          '//assets.squarespace.com/universal/scripts-compressed/extract-css-runtime-af6822c878021ad34e65-min.en-US.js'
        ];
      })(SQUARESPACE_ROLLUPS, 'squarespace-extract_css_runtime');
    </script>
    <script
      crossorigin="anonymous"
      src="//assets.squarespace.com/universal/scripts-compressed/extract-css-runtime-af6822c878021ad34e65-min.en-US.js"
      defer></script>
    <script>
      (function (rollups, name) {
        if (!rollups[name]) {
          rollups[name] = {};
        }
        rollups[name].js = [
          '//assets.squarespace.com/universal/scripts-compressed/extract-css-moment-js-vendor-c4d588d4255cd4c70fa3-min.en-US.js'
        ];
      })(SQUARESPACE_ROLLUPS, 'squarespace-extract_css_moment_js_vendor');
    </script>
    <script
      crossorigin="anonymous"
      src="//assets.squarespace.com/universal/scripts-compressed/extract-css-moment-js-vendor-c4d588d4255cd4c70fa3-min.en-US.js"
      defer></script>
    <script>
      (function (rollups, name) {
        if (!rollups[name]) {
          rollups[name] = {};
        }
        rollups[name].js = [
          '//assets.squarespace.com/universal/scripts-compressed/cldr-resource-pack-0c96ad3f9948c3a7b631-min.en-US.js'
        ];
      })(SQUARESPACE_ROLLUPS, 'squarespace-cldr_resource_pack');
    </script>
    <script
      crossorigin="anonymous"
      src="//assets.squarespace.com/universal/scripts-compressed/cldr-resource-pack-0c96ad3f9948c3a7b631-min.en-US.js"
      defer></script>
    <script>
      (function (rollups, name) {
        if (!rollups[name]) {
          rollups[name] = {};
        }
        rollups[name].js = [
          '//assets.squarespace.com/universal/scripts-compressed/common-vendors-stable-2965e1fc774101038a7d-min.en-US.js'
        ];
      })(SQUARESPACE_ROLLUPS, 'squarespace-common_vendors_stable');
    </script>
    <script
      crossorigin="anonymous"
      src="//assets.squarespace.com/universal/scripts-compressed/common-vendors-stable-2965e1fc774101038a7d-min.en-US.js"
      defer></script>
    <script>
      (function (rollups, name) {
        if (!rollups[name]) {
          rollups[name] = {};
        }
        rollups[name].js = [
          '//assets.squarespace.com/universal/scripts-compressed/common-vendors-8921de8f24d51c37e1bd-min.en-US.js'
        ];
      })(SQUARESPACE_ROLLUPS, 'squarespace-common_vendors');
    </script>
    <script
      crossorigin="anonymous"
      src="//assets.squarespace.com/universal/scripts-compressed/common-vendors-8921de8f24d51c37e1bd-min.en-US.js"
      defer></script>
    <script>
      (function (rollups, name) {
        if (!rollups[name]) {
          rollups[name] = {};
        }
        rollups[name].js = [
          '//assets.squarespace.com/universal/scripts-compressed/common-4575fb66a4f368aae0d1-min.en-US.js'
        ];
      })(SQUARESPACE_ROLLUPS, 'squarespace-common');
    </script>
    <script
      crossorigin="anonymous"
      src="//assets.squarespace.com/universal/scripts-compressed/common-4575fb66a4f368aae0d1-min.en-US.js"
      defer></script>
    <script>
      (function (rollups, name) {
        if (!rollups[name]) {
          rollups[name] = {};
        }
        rollups[name].js = [
          '//assets.squarespace.com/universal/scripts-compressed/performance-daea797f26ec33aee348-min.en-US.js'
        ];
      })(SQUARESPACE_ROLLUPS, 'squarespace-performance');
    </script>
    <script
      crossorigin="anonymous"
      src="//assets.squarespace.com/universal/scripts-compressed/performance-daea797f26ec33aee348-min.en-US.js"
      defer></script>
    <script data-name="static-context">
      Static = window.Static || {};
      Static.SQUARESPACE_CONTEXT = {
        betaFeatureFlags: [
          'marketing_automations',
          'member_areas_feature',
          'contacts_and_campaigns_redesign',
          'new_stacked_index',
          'nested_categories',
          'campaigns_thumbnail_layout',
          'i18n_beta_website_locales',
          'campaigns_discount_section_in_blasts',
          'campaigns_import_discounts',
          'campaigns_discount_section_in_automations',
          'marketing_landing_page',
          'supports_versioned_template_assets',
          'campaigns_new_image_layout_picker',
          'override_block_styles',
          'collection_typename_switching',
          'themes',
          'scripts_defer'
        ],
        facebookAppId: '314192535267336',
        facebookApiVersion: 'v6.0',
        rollups: {
          'squarespace-announcement-bar': {
            js: '//assets.squarespace.com/universal/scripts-compressed/announcement-bar-e58c2c256fc771df196f-min.en-US.js'
          },
          'squarespace-audio-player': {
            css: '//assets.squarespace.com/universal/styles-compressed/audio-player-7273fb3c727315fb7087-min.en-US.css',
            js: '//assets.squarespace.com/universal/scripts-compressed/audio-player-73979cf5715b90ec9b51-min.en-US.js'
          },
          'squarespace-blog-collection-list': {
            css: '//assets.squarespace.com/universal/styles-compressed/blog-collection-list-04589f0ab778d39b6f29-min.en-US.css',
            js: '//assets.squarespace.com/universal/scripts-compressed/blog-collection-list-3b161a94b70c22562b65-min.en-US.js'
          },
          'squarespace-calendar-block-renderer': {
            css: '//assets.squarespace.com/universal/styles-compressed/calendar-block-renderer-45e10dd8aac6cdf250c5-min.en-US.css',
            js: '//assets.squarespace.com/universal/scripts-compressed/calendar-block-renderer-8aa9b0cbeb4b1382de47-min.en-US.js'
          },
          'squarespace-chartjs-helpers': {
            css: '//assets.squarespace.com/universal/styles-compressed/chartjs-helpers-035fad01719b3ad44ea0-min.en-US.css',
            js: '//assets.squarespace.com/universal/scripts-compressed/chartjs-helpers-87bcc1cf71dc32506780-min.en-US.js'
          },
          'squarespace-comments': {
            css: '//assets.squarespace.com/universal/styles-compressed/comments-8d82b7dcc10a49d8f3ab-min.en-US.css',
            js: '//assets.squarespace.com/universal/scripts-compressed/comments-1ba83c0b3b745fb75907-min.en-US.js'
          },
          'squarespace-custom-css-popup': {
            css: '//assets.squarespace.com/universal/styles-compressed/custom-css-popup-42165bae3117a373beba-min.en-US.css',
            js: '//assets.squarespace.com/universal/scripts-compressed/custom-css-popup-9fd142ac50a77a92eb80-min.en-US.js'
          },
          'squarespace-dialog': {
            css: '//assets.squarespace.com/universal/styles-compressed/dialog-4442f8c03c49894df614-min.en-US.css',
            js: '//assets.squarespace.com/universal/scripts-compressed/dialog-3c204698eb988e00b67c-min.en-US.js'
          },
          'squarespace-events-collection': {
            css: '//assets.squarespace.com/universal/styles-compressed/events-collection-45e10dd8aac6cdf250c5-min.en-US.css',
            js: '//assets.squarespace.com/universal/scripts-compressed/events-collection-ab0904713c7bec57a263-min.en-US.js'
          },
          'squarespace-form-rendering-utils': {
            js: '//assets.squarespace.com/universal/scripts-compressed/form-rendering-utils-9dbd9ab8f7fe48dd0912-min.en-US.js'
          },
          'squarespace-forms': {
            css: '//assets.squarespace.com/universal/styles-compressed/forms-561e399da7e8cd21136e-min.en-US.css',
            js: '//assets.squarespace.com/universal/scripts-compressed/forms-460e44eec8302ce495d5-min.en-US.js'
          },
          'squarespace-gallery-collection-list': {
            css: '//assets.squarespace.com/universal/styles-compressed/gallery-collection-list-04589f0ab778d39b6f29-min.en-US.css',
            js: '//assets.squarespace.com/universal/scripts-compressed/gallery-collection-list-6a695d6f503d6f274456-min.en-US.js'
          },
          'squarespace-image-zoom': {
            css: '//assets.squarespace.com/universal/styles-compressed/image-zoom-04589f0ab778d39b6f29-min.en-US.css',
            js: '//assets.squarespace.com/universal/scripts-compressed/image-zoom-86a4f1190d4dd0a1bb85-min.en-US.js'
          },
          'squarespace-pinterest': {
            css: '//assets.squarespace.com/universal/styles-compressed/pinterest-04589f0ab778d39b6f29-min.en-US.css',
            js: '//assets.squarespace.com/universal/scripts-compressed/pinterest-4db8797e0ab9916b74bc-min.en-US.js'
          },
          'squarespace-popup-overlay': {
            css: '//assets.squarespace.com/universal/styles-compressed/popup-overlay-1953548b82872bd9f153-min.en-US.css',
            js: '//assets.squarespace.com/universal/scripts-compressed/popup-overlay-abef1bd20e88ee2b0ff6-min.en-US.js'
          },
          'squarespace-product-quick-view': {
            css: '//assets.squarespace.com/universal/styles-compressed/product-quick-view-cabe0d0e788aff914259-min.en-US.css',
            js: '//assets.squarespace.com/universal/scripts-compressed/product-quick-view-ae1191dd37ba355c2d16-min.en-US.js'
          },
          'squarespace-products-collection-item-v2': {
            css: '//assets.squarespace.com/universal/styles-compressed/products-collection-item-v2-04589f0ab778d39b6f29-min.en-US.css',
            js: '//assets.squarespace.com/universal/scripts-compressed/products-collection-item-v2-bc54407b17c1344e3754-min.en-US.js'
          },
          'squarespace-products-collection-list-v2': {
            css: '//assets.squarespace.com/universal/styles-compressed/products-collection-list-v2-04589f0ab778d39b6f29-min.en-US.css',
            js: '//assets.squarespace.com/universal/scripts-compressed/products-collection-list-v2-320bbe708a4fc56f6d2e-min.en-US.js'
          },
          'squarespace-search-page': {
            css: '//assets.squarespace.com/universal/styles-compressed/search-page-efbf373f59490877e106-min.en-US.css',
            js: '//assets.squarespace.com/universal/scripts-compressed/search-page-070b8b054bdeaedce608-min.en-US.js'
          },
          'squarespace-search-preview': {
            js: '//assets.squarespace.com/universal/scripts-compressed/search-preview-ad37c6d6b6aef9eab4d8-min.en-US.js'
          },
          'squarespace-simple-liking': {
            css: '//assets.squarespace.com/universal/styles-compressed/simple-liking-87ea620354232c2e7b9f-min.en-US.css',
            js: '//assets.squarespace.com/universal/scripts-compressed/simple-liking-b240c4039cac2761e6d0-min.en-US.js'
          },
          'squarespace-social-buttons': {
            css: '//assets.squarespace.com/universal/styles-compressed/social-buttons-7430c3ff0790eafdec2c-min.en-US.css',
            js: '//assets.squarespace.com/universal/scripts-compressed/social-buttons-1eefd456ab26aca444a7-min.en-US.js'
          },
          'squarespace-tourdates': {
            css: '//assets.squarespace.com/universal/styles-compressed/tourdates-04589f0ab778d39b6f29-min.en-US.css',
            js: '//assets.squarespace.com/universal/scripts-compressed/tourdates-6a57cd3d6dd5f8c36147-min.en-US.js'
          },
          'squarespace-website-overlays-manager': {
            css: '//assets.squarespace.com/universal/styles-compressed/website-overlays-manager-a81f4f351e0b41eedf7d-min.en-US.css',
            js: '//assets.squarespace.com/universal/scripts-compressed/website-overlays-manager-81328279e26303ecdcd4-min.en-US.js'
          }
        },
        pageType: 2,
        website: {
          id: '6511a2cb1aa9fb5b4606268a',
          identifier: 'lobster-reed-cf94',
          websiteType: 1,
          contentModifiedOn: 1738856923875,
          cloneable: false,
          hasBeenCloneable: false,
          siteStatus: {},
          language: 'en-US',
          timeZone: 'America/Denver',
          machineTimeZoneOffset: -25200000,
          timeZoneOffset: -25200000,
          timeZoneAbbr: 'MST',
          siteTitle: 'REFORM IS COMING',
          fullSiteTitle: 'Privacy Policy \u2014 REFORM IS COMING',
          siteDescription: '',
          location: {},
          shareButtonOptions: { 2: true, 4: true, 3: true, 1: true, 6: true, 7: true, 8: true },
          authenticUrl: 'https://www.thereligionbusiness.com',
          internalUrl: 'https://lobster-reed-cf94.squarespace.com',
          baseUrl: 'https://www.thereligionbusiness.com',
          primaryDomain: 'www.thereligionbusiness.com',
          sslSetting: 3,
          isHstsEnabled: true,
          socialAccounts: [
            {
              serviceId: 64,
              screenname: 'Instagram',
              addedOn: 1695654604169,
              profileUrl: 'https://www.instagram.com/religionbusiness',
              iconEnabled: true,
              serviceName: 'instagram-unauth'
            },
            {
              serviceId: 62,
              screenname: 'Twitter',
              addedOn: 1695657525054,
              profileUrl: 'http://twitter.com/religionbiz',
              iconEnabled: true,
              serviceName: 'twitter-unauth'
            },
            {
              serviceId: 65,
              screenname: 'LinkedIn',
              addedOn: 1735237069087,
              profileUrl: 'https://www.linkedin.com/company/the-religion-business/about/?viewAsMember=true',
              iconEnabled: true,
              serviceName: 'linkedin-unauth'
            }
          ],
          typekitId: '',
          statsMigrated: false,
          imageMetadataProcessingEnabled: false,
          screenshotId: 'd834cebe06094e7feb953401350445fed5b1dc8cf7b27687fe4e3020312cb074',
          captchaSettings: { enabledForDonations: false },
          showOwnerLogin: false
        },
        websiteSettings: {
          id: '6511a2cc1aa9fb5b4606268d',
          websiteId: '6511a2cb1aa9fb5b4606268a',
          subjects: [],
          country: 'US',
          state: 'CO',
          simpleLikingEnabled: true,
          popupOverlaySettings: { style: 1, enabledPages: [] },
          commentLikesAllowed: true,
          commentAnonAllowed: true,
          commentThreaded: true,
          commentApprovalRequired: false,
          commentAvatarsOn: true,
          commentSortType: 2,
          commentFlagThreshold: 0,
          commentFlagsAllowed: true,
          commentEnableByDefault: true,
          commentDisableAfterDaysDefault: 0,
          disqusShortname: '',
          commentsEnabled: false,
          storeSettings: {
            returnPolicy: null,
            termsOfService: null,
            privacyPolicy: null,
            expressCheckout: false,
            continueShoppingLinkUrl: '/',
            useLightCart: false,
            showNoteField: false,
            shippingCountryDefaultValue: 'US',
            billToShippingDefaultValue: false,
            showShippingPhoneNumber: true,
            isShippingPhoneRequired: false,
            showBillingPhoneNumber: true,
            isBillingPhoneRequired: false,
            currenciesSupported: [
              'USD',
              'CAD',
              'GBP',
              'AUD',
              'EUR',
              'CHF',
              'NOK',
              'SEK',
              'DKK',
              'NZD',
              'SGD',
              'MXN',
              'HKD',
              'CZK',
              'ILS',
              'MYR',
              'RUB',
              'PHP',
              'PLN',
              'THB',
              'BRL',
              'ARS',
              'COP',
              'IDR',
              'INR',
              'JPY',
              'ZAR'
            ],
            defaultCurrency: 'USD',
            selectedCurrency: 'USD',
            measurementStandard: 1,
            showCustomCheckoutForm: false,
            checkoutPageMarketingOptInEnabled: true,
            enableMailingListOptInByDefault: false,
            sameAsRetailLocation: false,
            merchandisingSettings: {
              scarcityEnabledOnProductItems: false,
              scarcityEnabledOnProductBlocks: false,
              scarcityMessageType: 'DEFAULT_SCARCITY_MESSAGE',
              scarcityThreshold: 10,
              multipleQuantityAllowedForServices: true,
              restockNotificationsEnabled: false,
              restockNotificationsSuccessText: '',
              restockNotificationsMailingListSignUpEnabled: false,
              relatedProductsEnabled: false,
              relatedProductsOrdering: 'random',
              soldOutVariantsDropdownDisabled: false,
              productComposerOptedIn: false,
              productComposerABTestOptedOut: false,
              productReviewsEnabled: false
            },
            minimumOrderSubtotalEnabled: false,
            minimumOrderSubtotal: { currency: 'USD', value: '0.00' },
            isLive: false,
            multipleQuantityAllowedForServices: true
          },
          useEscapeKeyToLogin: false,
          ssBadgeType: 1,
          ssBadgePosition: 4,
          ssBadgeVisibility: 1,
          ssBadgeDevices: 1,
          pinterestOverlayOptions: { mode: 'disabled' },
          ampEnabled: false,
          userAccountsSettings: { loginAllowed: false, signupAllowed: false }
        },
        cookieSettings: {
          isCookieBannerEnabled: false,
          isRestrictiveCookiePolicyEnabled: false,
          cookieBannerText: '',
          cookieBannerTheme: '',
          cookieBannerVariant: '',
          cookieBannerPosition: '',
          cookieBannerCtaVariant: '',
          cookieBannerCtaText: '',
          cookieBannerAcceptType: 'OPT_IN',
          cookieBannerOptOutCtaText: '',
          cookieBannerHasOptOut: false,
          cookieBannerHasManageCookies: true,
          cookieBannerManageCookiesLabel: '',
          cookieBannerSavedPreferencesText: '',
          cookieBannerSavedPreferencesLayout: 'PILL'
        },
        websiteCloneable: false,
        collection: {
          title: 'Privacy Policy',
          id: '6511c13e76ef5b0b7e7c8527',
          fullUrl: '/privacy-policy',
          type: 10,
          permissionType: 1
        },
        subscribed: false,
        appDomain: 'squarespace.com',
        templateTweakable: true,
        tweakJSON: {
          'form-use-theme-colors': 'false',
          'header-logo-height': '20px',
          'header-mobile-logo-max-height': '30px',
          'header-vert-padding': '1.5vw',
          'header-width': 'Inset',
          maxPageWidth: '1400px',
          pagePadding: '2vw',
          'tweak-blog-alternating-side-by-side-image-aspect-ratio': '1:1 Square',
          'tweak-blog-alternating-side-by-side-image-spacing': '6%',
          'tweak-blog-alternating-side-by-side-meta-spacing': '20px',
          'tweak-blog-alternating-side-by-side-primary-meta': 'Categories',
          'tweak-blog-alternating-side-by-side-read-more-spacing': '20px',
          'tweak-blog-alternating-side-by-side-secondary-meta': 'Date',
          'tweak-blog-basic-grid-columns': '3',
          'tweak-blog-basic-grid-image-aspect-ratio': '1:1 Square',
          'tweak-blog-basic-grid-image-spacing': '30px',
          'tweak-blog-basic-grid-meta-spacing': '17px',
          'tweak-blog-basic-grid-primary-meta': 'Categories',
          'tweak-blog-basic-grid-read-more-spacing': '37px',
          'tweak-blog-basic-grid-secondary-meta': 'Date',
          'tweak-blog-item-custom-width': '75',
          'tweak-blog-item-show-author-profile': 'false',
          'tweak-blog-item-width': 'Narrow',
          'tweak-blog-masonry-columns': '2',
          'tweak-blog-masonry-horizontal-spacing': '64px',
          'tweak-blog-masonry-image-spacing': '20px',
          'tweak-blog-masonry-meta-spacing': '10px',
          'tweak-blog-masonry-primary-meta': 'Categories',
          'tweak-blog-masonry-read-more-spacing': '22px',
          'tweak-blog-masonry-secondary-meta': 'Date',
          'tweak-blog-masonry-vertical-spacing': '231px',
          'tweak-blog-side-by-side-image-aspect-ratio': '1:1 Square',
          'tweak-blog-side-by-side-image-spacing': '6%',
          'tweak-blog-side-by-side-meta-spacing': '20px',
          'tweak-blog-side-by-side-primary-meta': 'Categories',
          'tweak-blog-side-by-side-read-more-spacing': '20px',
          'tweak-blog-side-by-side-secondary-meta': 'Date',
          'tweak-blog-single-column-image-spacing': '50px',
          'tweak-blog-single-column-meta-spacing': '30px',
          'tweak-blog-single-column-primary-meta': 'Categories',
          'tweak-blog-single-column-read-more-spacing': '30px',
          'tweak-blog-single-column-secondary-meta': 'Date',
          'tweak-events-stacked-show-thumbnails': 'true',
          'tweak-events-stacked-thumbnail-size': '3:2 Standard',
          'tweak-fixed-header': 'false',
          'tweak-fixed-header-style': 'Scroll Back',
          'tweak-global-animations-animation-curve': 'ease',
          'tweak-global-animations-animation-delay': '0.6s',
          'tweak-global-animations-animation-duration': '1.50s',
          'tweak-global-animations-animation-style': 'fade',
          'tweak-global-animations-animation-type': 'fade',
          'tweak-global-animations-complexity-level': 'detailed',
          'tweak-global-animations-enabled': 'true',
          'tweak-portfolio-grid-basic-custom-height': '50',
          'tweak-portfolio-grid-overlay-custom-height': '50',
          'tweak-portfolio-hover-follow-acceleration': '10%',
          'tweak-portfolio-hover-follow-animation-duration': 'Fast',
          'tweak-portfolio-hover-follow-animation-type': 'Fade',
          'tweak-portfolio-hover-follow-delimiter': 'Bullet',
          'tweak-portfolio-hover-follow-front': 'false',
          'tweak-portfolio-hover-follow-layout': 'Inline',
          'tweak-portfolio-hover-follow-size': '50',
          'tweak-portfolio-hover-follow-text-spacing-x': '1.5',
          'tweak-portfolio-hover-follow-text-spacing-y': '1.5',
          'tweak-portfolio-hover-static-animation-duration': 'Fast',
          'tweak-portfolio-hover-static-animation-type': 'Fade',
          'tweak-portfolio-hover-static-delimiter': 'Hyphen',
          'tweak-portfolio-hover-static-front': 'true',
          'tweak-portfolio-hover-static-layout': 'Inline',
          'tweak-portfolio-hover-static-size': '50',
          'tweak-portfolio-hover-static-text-spacing-x': '1.5',
          'tweak-portfolio-hover-static-text-spacing-y': '1.5',
          'tweak-portfolio-index-background-animation-duration': 'Medium',
          'tweak-portfolio-index-background-animation-type': 'Fade',
          'tweak-portfolio-index-background-custom-height': '50',
          'tweak-portfolio-index-background-delimiter': 'None',
          'tweak-portfolio-index-background-height': 'Large',
          'tweak-portfolio-index-background-horizontal-alignment': 'Center',
          'tweak-portfolio-index-background-link-format': 'Stacked',
          'tweak-portfolio-index-background-persist': 'false',
          'tweak-portfolio-index-background-vertical-alignment': 'Middle',
          'tweak-portfolio-index-background-width': 'Full',
          'tweak-product-basic-item-click-action': 'None',
          'tweak-product-basic-item-gallery-aspect-ratio': '1:1 Square',
          'tweak-product-basic-item-gallery-design': 'Slideshow',
          'tweak-product-basic-item-gallery-width': '53%',
          'tweak-product-basic-item-hover-action': 'Zoom',
          'tweak-product-basic-item-image-spacing': '10vw',
          'tweak-product-basic-item-image-zoom-factor': '1.5',
          'tweak-product-basic-item-product-variant-display': 'Dropdown',
          'tweak-product-basic-item-thumbnail-placement': 'Side',
          'tweak-product-basic-item-variant-picker-layout': 'Dropdowns',
          'tweak-products-add-to-cart-button': 'false',
          'tweak-products-columns': '2',
          'tweak-products-gutter-column': '2vw',
          'tweak-products-gutter-row': '4vw',
          'tweak-products-header-text-alignment': 'Middle',
          'tweak-products-image-aspect-ratio': '1:1 Square',
          'tweak-products-image-text-spacing': '2vw',
          'tweak-products-mobile-columns': '1',
          'tweak-products-text-alignment': 'Middle',
          'tweak-products-width': 'Inset',
          'tweak-transparent-header': 'false'
        },
        templateId: '5c5a519771c10ba3470d8101',
        templateVersion: '7.1',
        pageFeatures: [1, 2, 4],
        gmRenderKey: 'QUl6YVN5Q0JUUk9xNkx1dkZfSUUxcjQ2LVQ0QWVUU1YtMGQ3bXk4',
        templateScriptsRootUrl: 'https://static1.squarespace.com/static/vta/5c5a519771c10ba3470d8101/scripts/',
        impersonatedSession: false,
        tzData: {
          zones: [[-420, 'US', 'M%sT', null]],
          rules: {
            US: [
              [1967, 2006, null, 'Oct', 'lastSun', '2:00', '0', 'S'],
              [1987, 2006, null, 'Apr', 'Sun>=1', '2:00', '1:00', 'D'],
              [2007, 'max', null, 'Mar', 'Sun>=8', '2:00', '1:00', 'D'],
              [2007, 'max', null, 'Nov', 'Sun>=1', '2:00', '0', 'S']
            ]
          }
        },
        showAnnouncementBar: false,
        recaptchaEnterpriseContext: { recaptchaEnterpriseSiteKey: '6LdDFQwjAAAAAPigEvvPgEVbb7QBm-TkVJdDTlAv' },
        i18nContext: { timeZoneData: { id: 'America/Denver', name: 'Mountain Time' } },
        env: 'PRODUCTION'
      };
    </script>
    <script type="application/ld+json">
      {
        "url": "https://www.thereligionbusiness.com",
        "name": "REFORM IS COMING",
        "description": "",
        "@context": "http://schema.org",
        "@type": "WebSite"
      }
    </script>
    <script type="application/ld+json">
      { "address": "", "@context": "http://schema.org", "@type": "LocalBusiness" }
    </script>
    <link
      rel="stylesheet"
      type="text/css"
      href="https://static1.squarespace.com/static/versioned-site-css/6511a2cb1aa9fb5b4606268a/28/5c5a519771c10ba3470d8101/6511a2cc1aa9fb5b46062692/1612/site.css" />
    <script>
      Static.COOKIE_BANNER_CAPABLE = true;
    </script>
    <!-- End of Squarespace Headers -->
    <link
      rel="stylesheet"
      type="text/css"
      href="https://static1.squarespace.com/static/vta/5c5a519771c10ba3470d8101/versioned-assets/1739381320286-8FJE7NMLDZWANM5PXDLU/static.css" />
  </head>

  <body
    id="collection-6511c13e76ef5b0b7e7c8527"
    class="tweak-products-width-inset tweak-products-image-aspect-ratio-11-square tweak-products-text-alignment-middle tweak-products-price-show tweak-products-nested-category-type-top tweak-products-header-text-alignment-middle tweak-products-breadcrumbs tweak-portfolio-grid-overlay-width-full tweak-portfolio-grid-overlay-height-large tweak-portfolio-grid-overlay-image-aspect-ratio-11-square tweak-portfolio-grid-overlay-text-placement-center tweak-portfolio-grid-overlay-show-text-after-hover image-block-poster-text-alignment-center image-block-card-content-position-center image-block-card-text-alignment-left image-block-overlap-content-position-center image-block-overlap-text-alignment-left image-block-collage-content-position-center image-block-collage-text-alignment-center image-block-stack-text-alignment-left tweak-blog-single-column-width-inset tweak-blog-single-column-text-alignment-center tweak-blog-single-column-image-placement-above tweak-blog-single-column-delimiter-bullet tweak-blog-single-column-read-more-style-show tweak-blog-single-column-primary-meta-categories tweak-blog-single-column-secondary-meta-date tweak-blog-single-column-meta-position-top tweak-blog-single-column-content-full-post tweak-blog-item-width-narrow tweak-blog-item-text-alignment-left tweak-blog-item-meta-position-above-title tweak-blog-item-show-date tweak-blog-item-delimiter-bullet primary-button-style-solid primary-button-shape-pill secondary-button-style-outline secondary-button-shape-pill tertiary-button-style-outline tertiary-button-shape-pill tweak-events-stacked-width-full tweak-events-stacked-height-large tweak-events-stacked-show-thumbnails tweak-events-stacked-thumbnail-size-32-standard tweak-events-stacked-date-style-with-text tweak-events-stacked-show-time tweak-events-stacked-show-location tweak-events-stacked-show-excerpt tweak-blog-basic-grid-width-full tweak-blog-basic-grid-image-aspect-ratio-11-square tweak-blog-basic-grid-text-alignment-left tweak-blog-basic-grid-delimiter-bullet tweak-blog-basic-grid-image-placement-above tweak-blog-basic-grid-read-more-style-hide tweak-blog-basic-grid-primary-meta-categories tweak-blog-basic-grid-secondary-meta-date tweak-blog-basic-grid-excerpt-hide header-overlay-alignment-center tweak-portfolio-index-background-link-format-stacked tweak-portfolio-index-background-width-full tweak-portfolio-index-background-height-large tweak-portfolio-index-background-vertical-alignment-middle tweak-portfolio-index-background-horizontal-alignment-center tweak-portfolio-index-background-delimiter-none tweak-portfolio-index-background-animation-type-fade tweak-portfolio-index-background-animation-duration-medium tweak-portfolio-hover-follow-layout-inline tweak-portfolio-hover-follow-delimiter-bullet tweak-portfolio-hover-follow-animation-type-fade tweak-portfolio-hover-follow-animation-duration-fast tweak-portfolio-hover-static-layout-inline tweak-portfolio-hover-static-front tweak-portfolio-hover-static-delimiter-hyphen tweak-portfolio-hover-static-animation-type-fade tweak-portfolio-hover-static-animation-duration-fast form-field-style-solid form-field-shape-square form-field-border-all form-field-checkbox-type-icon form-field-checkbox-fill-solid form-field-checkbox-color-inverted form-field-checkbox-shape-square form-field-checkbox-layout-stack form-field-radio-type-icon form-field-radio-fill-solid form-field-radio-color-normal form-field-radio-shape-pill form-field-radio-layout-stack form-field-survey-fill-solid form-field-survey-color-normal form-field-survey-shape-pill form-field-hover-focus-outline form-submit-button-style-label tweak-blog-alternating-side-by-side-width-full tweak-blog-alternating-side-by-side-image-aspect-ratio-11-square tweak-blog-alternating-side-by-side-text-alignment-left tweak-blog-alternating-side-by-side-read-more-style-hide tweak-blog-alternating-side-by-side-image-text-alignment-middle tweak-blog-alternating-side-by-side-delimiter-bullet tweak-blog-alternating-side-by-side-meta-position-top tweak-blog-alternating-side-by-side-primary-meta-categories tweak-blog-alternating-side-by-side-secondary-meta-date tweak-blog-alternating-side-by-side-excerpt-show tweak-global-animations-enabled tweak-global-animations-complexity-level-detailed tweak-global-animations-animation-style-fade tweak-global-animations-animation-type-fade tweak-global-animations-animation-curve-ease tweak-blog-masonry-width-inset tweak-blog-masonry-text-alignment-center tweak-blog-masonry-primary-meta-categories tweak-blog-masonry-secondary-meta-date tweak-blog-masonry-meta-position-top tweak-blog-masonry-read-more-style-hide tweak-blog-masonry-delimiter-space tweak-blog-masonry-image-placement-above tweak-blog-masonry-excerpt-show tweak-product-basic-item-product-variant-display-dropdown tweak-product-basic-item-product-subscription-display-radio tweak-product-basic-item-product-subscription-border-shape-square tweak-product-basic-item-width-full tweak-product-basic-item-gallery-aspect-ratio-11-square tweak-product-basic-item-text-alignment-left tweak-product-basic-item-navigation-none tweak-product-basic-item-description-position-below-price tweak-product-basic-item-description-position-mobile-below-add-to-cart-button tweak-product-basic-item-content-alignment-top tweak-product-basic-item-gallery-design-slideshow tweak-product-basic-item-gallery-placement-right tweak-product-basic-item-thumbnail-placement-side tweak-product-basic-item-click-action-none tweak-product-basic-item-hover-action-zoom tweak-product-basic-item-variant-picker-layout-dropdowns tweak-product-basic-item-add-to-cart-standalone tweak-product-basic-item-add-to-cart-mobile-standalone header-width-inset tweak-fixed-header-style-scroll-back tweak-blog-side-by-side-width-inset tweak-blog-side-by-side-image-placement-left tweak-blog-side-by-side-image-aspect-ratio-11-square tweak-blog-side-by-side-primary-meta-categories tweak-blog-side-by-side-secondary-meta-date tweak-blog-side-by-side-meta-position-top tweak-blog-side-by-side-text-alignment-left tweak-blog-side-by-side-image-text-alignment-middle tweak-blog-side-by-side-read-more-style-show tweak-blog-side-by-side-delimiter-bullet tweak-blog-side-by-side-excerpt-show tweak-portfolio-grid-basic-width-full tweak-portfolio-grid-basic-height-small tweak-portfolio-grid-basic-image-aspect-ratio-11-square tweak-portfolio-grid-basic-text-alignment-left tweak-portfolio-grid-basic-hover-effect-fade hide-opentable-icons opentable-style-dark tweak-product-quick-view-button-style-floating tweak-product-quick-view-button-position-center tweak-product-quick-view-lightbox-excerpt-display-truncate tweak-product-quick-view-lightbox-show-arrows tweak-product-quick-view-lightbox-show-close-button tweak-product-quick-view-lightbox-controls-weight-light native-currency-code-usd collection-type-page collection-layout-default collection-6511c13e76ef5b0b7e7c8527 mobile-style-available sqs-seven-one"
    tabindex="-1">
    <div id="siteWrapper" class="clearfix site-wrapper">
      <div id="floatingCart" class="floating-cart hidden">
        <a href="/cart" class="icon icon--stroke icon--fill icon--cart sqs-custom-cart">
          <span class="Cart-inner">
            <svg class="icon icon--cart" viewBox="0 0 31 24">
              <g class="svg-icon cart-icon--odd">
                <circle fill="none" stroke-miterlimit="10" cx="22.5" cy="21.5" r="1" />
                <circle fill="none" stroke-miterlimit="10" cx="9.5" cy="21.5" r="1" />
                <path
                  fill="none"
                  stroke-miterlimit="10"
                  d="M0,1.5h5c0.6,0,1.1,0.4,1.1,1l1.7,13
      c0.1,0.5,0.6,1,1.1,1h15c0.5,0,1.2-0.4,1.4-0.9l3.3-8.1c0.2-0.5-0.1-0.9-0.6-0.9H12" />
              </g>
            </svg>

            <div class="legacy-cart icon-cart-quantity">
              <span class="sqs-cart-quantity">0</span>
            </div>
          </span>
        </a>
      </div>
      <main id="page" class="container" role="main">
        <article class="sections" id="sections" data-page-sections="6511c13e76ef5b0b7e7c8526">
          <section
            data-test="page-section"
            data-section-theme=""
            class="page-section full-bleed-section layout-engine-section background-width--full-bleed section-height--custom content-width--wide horizontal-alignment--center vertical-alignment--middle"
            data-section-id="6511c13e76ef5b0b7e7c852a"
            data-controller="SectionWrapperController"
            data-current-styles='{
"imageOverlayOpacity": 0.15,
"backgroundWidth": "background-width--full-bleed",
"sectionHeight": "section-height--custom",
"customSectionHeight": 1,
"horizontalAlignment": "horizontal-alignment--center",
"verticalAlignment": "vertical-alignment--middle",
"contentWidth": "content-width--wide",
"customContentWidth": 50,
"sectionTheme": "",
"sectionAnimation": "none",
"backgroundMode": "image"
}'
            data-current-context='{
"video": {
"playbackSpeed": 0.5,
"filter": 1,
"filterStrength": 0,
"zoom": 0,
"videoSourceProvider": "none"
},
"backgroundImageId": null,
"backgroundMediaEffect": {
"type": "none"
},
"divider": {
"enabled": false
},
"typeName": "page"
}'
            data-animation="none"
            data-fluid-engine-section
            style="min-height: 1vh">
            <div class="section-border">
              <div class="section-background"></div>
            </div>
            <div class="content-wrapper" style="padding-top: calc(1vmax / 10); padding-bottom: calc(1vmax / 10)">
              <div class="content">
                <div data-fluid-engine="true">
                  <style>
                    .fe-6511c13e76ef5b0b7e7c8529 {
                      --grid-gutter: calc(var(--sqs-mobile-site-gutter, 6vw) - 11px);
                      --cell-max-width: calc((var(--sqs-site-max-width, 1500px) - (11px * (8 - 1))) / 8);

                      display: grid;
                      position: relative;
                      grid-area: 1/1/-1/-1;
                      grid-template-rows: repeat(31, minmax(24px, auto));
                      grid-template-columns:
                        minmax(var(--grid-gutter), 1fr)
                        repeat(8, minmax(0, var(--cell-max-width)))
                        minmax(var(--grid-gutter), 1fr);
                      row-gap: 11px;
                      column-gap: 11px;
                    }

                    @media (min-width: 768px) {
                      .background-width--inset .fe-6511c13e76ef5b0b7e7c8529 {
                        --inset-padding: calc(var(--sqs-site-gutter) * 2);
                      }

                      .fe-6511c13e76ef5b0b7e7c8529 {
                        --grid-gutter: calc(var(--sqs-site-gutter, 4vw) - 11px);
                        --cell-max-width: calc((var(--sqs-site-max-width, 1500px) - (11px * (24 - 1))) / 24);
                        --inset-padding: 0vw;

                        --row-height-scaling-factor: 0.0215;
                        --container-width: min(
                          var(--sqs-site-max-width, 1500px),
                          calc(100vw - var(--sqs-site-gutter, 4vw) * 2 - var(--inset-padding))
                        );

                        grid-template-rows: repeat(
                          251,
                          minmax(calc(var(--container-width) * var(--row-height-scaling-factor)), auto)
                        );
                        grid-template-columns:
                          minmax(var(--grid-gutter), 1fr)
                          repeat(24, minmax(0, var(--cell-max-width)))
                          minmax(var(--grid-gutter), 1fr);
                      }
                    }

                    .fe-block-96d0eb3dcea5bc4bcedc {
                      grid-area: 1/2/32/10;
                      z-index: 1;

                      @media (max-width: 767px) {
                      }
                    }

                    .fe-block-96d0eb3dcea5bc4bcedc .sqs-block {
                      justify-content: flex-start;
                    }

                    .fe-block-96d0eb3dcea5bc4bcedc .sqs-block-alignment-wrapper {
                      align-items: flex-start;
                    }

                    @media (min-width: 768px) {
                      .fe-block-96d0eb3dcea5bc4bcedc {
                        grid-area: 2/5/252/23;
                        z-index: 1;
                      }

                      .fe-block-96d0eb3dcea5bc4bcedc .sqs-block {
                        justify-content: flex-start;
                      }

                      .fe-block-96d0eb3dcea5bc4bcedc .sqs-block-alignment-wrapper {
                        align-items: flex-start;
                      }
                    }
                  </style>
                  <div class="fluid-engine fe-6511c13e76ef5b0b7e7c8529">
                    <div class="fe-block fe-block-96d0eb3dcea5bc4bcedc">
                      <div
                        class="sqs-block html-block sqs-block-html"
                        data-blend-mode="NORMAL"
                        data-block-type="2"
                        data-border-radii='&#123;"topLeft":&#123;"unit":"px","value":0.0&#125;,"topRight":&#123;"unit":"px","value":0.0&#125;,"bottomLeft":&#123;"unit":"px","value":0.0&#125;,"bottomRight":&#123;"unit":"px","value":0.0&#125;&#125;'
                        id="block-96d0eb3dcea5bc4bcedc">
                        <div class="sqs-block-content">
                          <div class="sqs-html-content">
                            <p class="" style="white-space: pre-wrap"><strong>TGC Privacy Policy</strong></p>
                            <p style="text-align: center; white-space: pre-wrap" class="">
                              Last Updated: December 1, 2024
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              <strong>1. Acceptance of Privacy Policy</strong>
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              Welcome to TGC NOW, LLC and its subsidiaries (“<span style="text-decoration: underline"
                                >TGC</span
                              >” “<span style="text-decoration: underline">we</span>” or “<span
                                style="text-decoration: underline"
                                >us</span
                              >”) and our Privacy Policy (“<span style="text-decoration: underline">Privacy Policy</span
                              >”). This Privacy Policy is important and affects your legal rights, so please read
                              carefully.
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              By accessing or using www.brokenshepherds.com and various related websites and services
                              (collectively, the “<span style="text-decoration: underline">TGC Services</span>”), you
                              agree to be bound by this Privacy Policy and all of the terms incorporated herein by
                              reference. By using the TGC Services and/or submitting or collecting any personal data via
                              the TGC Services, you accept and expressly consent and agree to our practices surrounding
                              the collection, use, and sharing of your personal information in accordance with this
                              Privacy Policy. If you do not consent and agree with the terms of this Privacy Policy, you
                              cannot, and we do not authorize you to, access, browse, or use the TGC Services.
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              Our processing of personal information, such as your name, address, e-mail address, or
                              telephone number, will be undertaken consistent with the requirements of applicable
                              privacy laws, including, but not limited to, the California Consumer Privacy Act (“<span
                                style="text-decoration: underline"
                                >CCPA</span
                              >”), the California Privacy Rights Act (“CPRA”), the Virginia Consumer Data Protection Act
                              of 2021, the Colorado Privacy Act of 2021, the Utah Consumer Privacy Act of 2022, the
                              Connecticut Data Privacy Act of 2022t, the EU General Data Protection Regulation (“<span
                                style="text-decoration: underline"
                                >GDPR</span
                              >”), the UK General Data Protection Regulation (“<span style="text-decoration: underline"
                                >UK GDPR</span
                              >”), and the Canadian Personal Information Protection and Electronic Documents Act (“<span
                                style="text-decoration: underline"
                                >PIPEDA</span
                              >”).
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              <strong>2.&nbsp;Information We Collect</strong>
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              <strong>2.1 Personal Information We Collect Directly from You</strong>
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              We receive personal information as described to you at the point of collection, pursuant
                              to your consent, and/or when you voluntarily provide us with personal information,
                              including:
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              (1)&nbsp;individual information&nbsp;(such as your e-mail address and phone number);
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              (2)&nbsp;company information (such as your company’s address); and
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              (3)&nbsp;other identifying information that you voluntarily choose to provide to us,
                              including without limitation unique identifiers such as passwords, and personal
                              information in messages you send to us.
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              We may also collect additional information, which may be personal information, as
                              otherwise described to you at the point of collection or pursuant to your consent.&nbsp;
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              <strong>2.2 Information We Automatically Collect When You Use Our Site</strong>
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              In order to access and use certain areas or features of the TGC Services, you consent to
                              our collection and use of certain information about your use of the TGC Services through
                              the use of tracking technologies or by other passive means. Your consent to our access and
                              use of this “passively collected” information includes, but is not limited to, the domain
                              name of the website that allowed you to navigate to the TGC Services, search engines used,
                              the internet protocol (IP) address used, the length of time spent on the TGC Services, the
                              pages you looked at on the TGC Services, other webpages you visited before and after
                              visiting the TGC Services, the type of device and/or internet browser you have, the
                              frequency of your visits to the TGC Services, and other relevant statistics (collectively
                              “<span style="text-decoration: underline">Traffic Data</span>”).
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              <strong>3.&nbsp;How We Collect Information</strong>
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              We collect information (including personal information and Traffic Data) when you use and
                              interact with the TGC Services, and in some cases from third party sources. Such means of
                              collection include:
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <ul data-rte-list="default">
                              <li>
                                <p class="" style="white-space: pre-wrap">
                                  When you access, use, or contact us through the TGC Services.
                                </p>
                              </li>
                              <li>
                                <p class="" style="white-space: pre-wrap">
                                  When you voluntarily provide information through the TGC Services.
                                </p>
                              </li>
                              <li>
                                <p class="" style="white-space: pre-wrap">
                                  If you use a location-enabled browser, we may receive information about your location
                                  and device.
                                </p>
                              </li>
                              <li>
                                <p class="" style="white-space: pre-wrap">
                                  Through Cookies, Web Beacons, analytics services, and other tracking technologies
                                  (collectively, “<span style="text-decoration: underline">Tracking Tools</span
                                  ><strong>”</strong>).
                                </p>
                              </li>
                            </ul>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              <strong>4.&nbsp;Tracking Tools, Behavioral Advertising, and Opt Out Options</strong>
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              <strong>4.1.&nbsp;Tracking Tools</strong>
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              We may use tools outlined below in order to provide the TGC Services, advertise to, and
                              better understand users.
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <ul data-rte-list="default">
                              <li>
                                <p class="" style="white-space: pre-wrap">
                                  <strong>Cookies:</strong> “<span style="text-decoration: underline">Cookies</span>”
                                  are small computer files transferred to your device that contain information such as
                                  user ID, user preferences, lists of pages visited and activities conducted while using
                                  the TGC Services. We use Cookies to: (i) improve and tailor the TGC Services, (ii)
                                  customize advertisements, (iii) measure performance, (iv) store authentication so
                                  re-entering credentials is not required, (v) customize user experiences, and for (vi)
                                  analytics and fraud prevention. For more information on Cookies, including how to
                                  control your Cookie settings and preferences, visit
                                  <a href="http://www.allaboutCookies.org"
                                    ><span style="text-decoration: underline">http://www.allaboutCookies.org</span></a
                                  >. You can also manage Cookies in your web browser (for example, Edge, Explorer,
                                  Chrome, Safari). If you choose to change your settings, you may find that certain
                                  functions or features of the TGC Services will not work as intended. The following
                                  details the types of Cookies we use and why we use them:
                                </p>
                              </li>
                            </ul>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <ul data-rte-list="default">
                              <ul data-rte-list="default">
                                <li>
                                  <p class="" style="white-space: pre-wrap">
                                    <span style="text-decoration: underline">Absolutely necessary Cookies.</span> These
                                    Cookies are essential to enable you to move around a website and use its features.
                                    Without these Cookies, services you have asked for, like adding items to an online
                                    order, cannot be provided.
                                  </p>
                                </li>
                              </ul>
                            </ul>
                            <p
                              style="
                                text-align: justify;
                                white-space: normal !important;
                                margin-left: 40px;
                                white-space: pre-wrap;
                              "
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <ul data-rte-list="default">
                              <ul data-rte-list="default">
                                <li>
                                  <p class="" style="white-space: pre-wrap">
                                    <span style="text-decoration: underline">Performance Cookies</span>. These Cookies
                                    collect information about how you use the TGC Services. Information collected
                                    includes, the Internet browsers and operating systems used, the domain name of the
                                    website previously visited, the number of visits, average duration of visit, and
                                    pages viewed. These Cookies do not collect information that personally identifies
                                    you and only collect aggregated and anonymous information. Performance Cookies are
                                    used to improve the user-friendliness of a website and enhance your experience.
                                  </p>
                                </li>
                              </ul>
                            </ul>
                            <p
                              style="
                                text-align: justify;
                                white-space: normal !important;
                                margin-left: 40px;
                                white-space: pre-wrap;
                              "
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <ul data-rte-list="default">
                              <ul data-rte-list="default">
                                <li>
                                  <p class="" style="white-space: pre-wrap">
                                    <span style="text-decoration: underline">Functionality Cookies.</span> These Cookies
                                    allow the TGC Services to remember choices you make (such as your username, language
                                    preference, or the area or region you are in) and provide enhanced, more personal
                                    features. These Cookies can also be used to remember changes you have made to text
                                    size, fonts, and other customizable parts of the TGC Services. The information these
                                    Cookies collect may be anonymized, and they cannot track your browsing activity on
                                    other websites.
                                  </p>
                                </li>
                              </ul>
                            </ul>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <ul data-rte-list="default">
                              <li>
                                <p class="" style="white-space: pre-wrap">
                                  <strong>Web Beacons:</strong> “<span style="text-decoration: underline"
                                    >Web Beacons</span
                                  >”&nbsp;(a.k.a.&nbsp;clear GIFs or pixel tags) are tiny graphic image files embedded
                                  in a web page or email that may be used to collect information about the use of the
                                  TGC Services. The information collected by Web Beacons allows us to analyze how many
                                  people are using the TGC Services, using selected publishers’ websites, or opening
                                  emails, and for what purpose.
                                </p>
                              </li>
                            </ul>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <ul data-rte-list="default">
                              <li>
                                <p class="" style="white-space: pre-wrap">
                                  <strong>Web Service Analytics:</strong>&nbsp; We may use third-party analytics
                                  services in connection with the TGC Services, including, for example, to register
                                  mouse clicks, mouse movements, scrolling activity and text typed into the TGC
                                  Services. We use the information collected from these services to help make the TGC
                                  Services easier to use and as otherwise set forth in Section 5 (How We Use Your
                                  Information). These analytics services generally do not collect personal information
                                  unless you voluntarily provide it.
                                </p>
                              </li>
                            </ul>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <ul data-rte-list="default">
                              <li>
                                <p class="" style="white-space: pre-wrap">
                                  <strong>Mobile Device Identifiers:</strong>&nbsp; As with other Tracking Tools, mobile
                                  device identifiers help TGC learn more about our users’ demographics and Internet
                                  behaviors in order to personalize and improve the TGC Services. Mobile device
                                  identifiers are data stored on mobile devices that may track activities occurring on
                                  and through it, as well as the applications installed on it.&nbsp; Mobile device
                                  identifiers enable collection of personal information&nbsp;(such as media access
                                  control, address, and location) and Traffic Data.
                                </p>
                              </li>
                            </ul>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              <strong>4.2.&nbsp;Behavioral Advertising</strong>
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              We may use a type of advertising commonly known as interest-based or online behavioral
                              advertising.&nbsp; This means that some of our partners use Tracking Tools to collect
                              information about a user’s online activities to display TGC ads to the user based on the
                              user’s interests&nbsp;(“<span style="text-decoration: underline"
                                >Behavioral Advertising</span
                              >”). Our partners may include third-party advertisers and other third-party service
                              providers, and such partners may collect information when you use the TGC Services, such
                              as IP address, mobile device ID, operating system, and demographic information. These
                              Tracking Tools help TGC learn more about our users’ demographics and Internet behaviors.
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              <strong>4.3.&nbsp;Options for Opting out of Cookies and Mobile Device Identifiers</strong>
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              If we process Cookies based on your consent (as indicated at the time of collection of
                              such data), you have the right to withdraw your consent at any point in time by contacting
                              us at info@TGC.com. Please note, if you exercise this right, you may have to provide your
                              consent on a case-by-case basis to enable you to utilize some or all of the TGC Services.
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              You may be able to reject Cookies and/or mobile device identifiers by activating the
                              appropriate setting on your browser or device. Although you are not required to accept
                              TGC’s Cookies or mobile device identifiers, if you block or reject them, you may not have
                              access to all features available through the TGC Services.
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <ul data-rte-list="default">
                              <li>
                                <p class="" style="white-space: pre-wrap">
                                  You may opt out of receiving certain Cookies by visiting the Network Advertising
                                  Initiative&nbsp;(NAI) opt out page or the Digital Advertising Alliance&nbsp;(DAA)
                                  <a href="https://privacyrights.info/"
                                    ><span style="text-decoration: underline">opt out page</span></a
                                  >, or by installing the DAA’s AppChoices app (for&nbsp;<a
                                    href="https://apps.apple.com/ca/app/appchoices/id894822870"
                                    ><span style="text-decoration: underline">iOS</span></a
                                  >; for&nbsp;<a
                                    href="https://play.google.com/store/apps/details?id=com.DAA.appchoices&amp;hl=en"
                                    ><span style="text-decoration: underline">Android</span></a
                                  >)&nbsp;on your mobile device. When you use these opt-out features, an “opt-out”
                                  Cookie will be placed on your device indicating that you do not want to receive
                                  interest-based advertising from NAI or DAA member companies. If you delete Cookies on
                                  your device, you may need to opt out again. For information about how to opt out of
                                  interest-based advertising on mobile devices, please visit
                                  <a
                                    href="http://www.applicationprivacy.org/expressing-your-behavioral-advertising-choices-on-a-mobile-device"
                                    ><span style="text-decoration: underline"
                                      >http://www.applicationprivacy.org/expressing-your-behavioral-advertising-choices-on-a-mobile-device</span
                                    ></a
                                  >. You will need to opt out of each browser and device for which you desire to apply
                                  these opt-out features.
                                </p>
                              </li>
                            </ul>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <ul data-rte-list="default">
                              <li>
                                <p class="" style="white-space: pre-wrap">
                                  Even after opting out of Behavioral Advertising, you may still see TGC advertisements
                                  that are not interest-based&nbsp;(i.e., not targeted toward you).&nbsp;Also, opting
                                  out does not mean that TGC is no longer using Tracking Tools. TGC still may collect
                                  information about your use of the TGC Services even after you have opted out of
                                  Behavioral Advertising and may still serve advertisements to you via the TGC Services
                                  based on information it collects through the TGC Services.
                                </p>
                              </li>
                            </ul>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              This Privacy Policy does not cover the use of Cookies and other Tracking Tools by any
                              third parties, and we are not responsible for the privacy practices of any third party.
                              Please be aware that some third-party Cookies can continue to track your activities online
                              even after you have left the TGC Services.
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="
                                text-align: justify;
                                white-space: normal !important;
                                margin-left: 120px;
                                white-space: pre-wrap;
                              "
                              class="">
                              <strong
                                >4.4.&nbsp; “Do Not Track”&nbsp;(DNT)&nbsp;and Universal Opt-Out Preference
                                Signals</strong
                              >
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              Some web browsers&nbsp;(including Safari, Internet Explorer, Firefox, and
                              Chrome)&nbsp;incorporate a “Do Not Track” (DNT) or similar feature that signals to web
                              services that a visitor does not want to have their online activity and behavior tracked.
                              If a web service operator elects to respond to a particular DNT signal, the web service
                              operator may refrain from collecting certain personal information about the browser’s
                              user. Not all browsers offer a DNT option and there is currently no industry consensus as
                              to what constitutes a DNT signal. For these reasons, many web service operators, including
                              TGC, do not proactively respond to DNT signals.&nbsp; For more information about DNT
                              signals, visit
                              <a href="http://allaboutdnt.com/"
                                ><span style="text-decoration: underline">http://allaboutdnt.com</span></a
                              >.
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              New standards are being developed for a Universal Opt-Out Mechanism, such as the Global
                              Privacy Control (GPC), which allow users with GPC-enabled browsers and devices to send a
                              signal that will communicate the user’s request to opt-out of sales of their personal
                              information and to opt-out of certain sharing of their personal information. The CPRA and
                              other laws allow for the acceptance of Opt-Out Preference Signals such as the GPC, as an
                              option for users to transmit an Opt-Out of selling/sharing personal information. If we
                              detect and recognize such a signal from your device or browser, we will honor it.
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              <strong>5.&nbsp;How We Use Your Information</strong>
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              We do not engage in automated decision making. We may use information (including
                              information that has been de-identified and/or aggregated) to better understand who uses
                              the TGC Services and how we can deliver a better user experience. We use information,
                              including personal information, to provide the TGC Services and to help improve the TGC
                              Services, to develop new services, and to advertise our services. Specifically, such use
                              may include:
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <ul data-rte-list="default">
                              <li>
                                <p class="" style="white-space: pre-wrap">
                                  Providing you with the products, services, and information you request.
                                </p>
                              </li>
                              <li><p class="" style="white-space: pre-wrap">Corresponding with you.</p></li>
                              <li>
                                <p class="" style="white-space: pre-wrap">
                                  Providing, maintaining, administering, or expanding the TGC Services, performing
                                  business analyses, and for other internal purposes.
                                </p>
                              </li>
                              <li>
                                <p class="" style="white-space: pre-wrap">
                                  Combining information received from third parties with information that we have from
                                  or about you and using the combined information for any of the purposes described in
                                  this Privacy Policy.
                                </p>
                              </li>
                              <li>
                                <p class="" style="white-space: pre-wrap">
                                  Showing you advertisements, including interest-based or online behavioral advertising.
                                </p>
                              </li>
                              <li>
                                <p class="" style="white-space: pre-wrap">
                                  Fulfilling our legal obligations, such as preventing, detecting, and investigating
                                  security incidents, fraud, and potentially illegal or prohibited activities.
                                </p>
                              </li>
                              <li>
                                <p class="" style="white-space: pre-wrap">
                                  Enforcing our Privacy Policy and other agreements.
                                </p>
                              </li>
                            </ul>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              By providing your e-mail and/or phone number and checking a box, clicking the “complete”
                              button, or some other affirmative act, you are consenting to receive e-mails and/or calls
                              and text messages, including live, prerecorded, and/or automated calls and messages, to
                              that email or phone number. After signing up, you will receive a confirmation e-mail or
                              text message from TGC on your mobile number. This agreement is not entered into as a term
                              or requirement of any purchase or promotion. Normal message and data rates may apply.
                              Message frequency may vary. Neither we nor the participating carriers guarantee that
                              messages will be delivered.&nbsp; We may discontinue these programs at any time without
                              notice.
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              <strong>6.&nbsp;How We Share Your Information</strong>
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              In certain circumstances, and in order to perform the TGC Services, we may share certain
                              information about you as described in this section:
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <ul data-rte-list="default">
                              <li>
                                <p class="" style="white-space: pre-wrap">
                                  We do not sell your personal information to third parties.
                                </p>
                              </li>
                              <li>
                                <p class="" style="white-space: pre-wrap">
                                  We may share your personal information with our partners to customize or display our
                                  advertising.
                                </p>
                              </li>
                              <li>
                                <p class="" style="white-space: pre-wrap">
                                  We may share your personal information and/or Traffic Data with our partners who
                                  perform operational services&nbsp;for us (such as hosting, billing, fulfillment, data
                                  storage, security, insurance verification, web service analytics, or ad serving).
                                </p>
                              </li>
                              <li>
                                <p class="" style="white-space: pre-wrap">
                                  We may share your personal information and/or Traffic Data with our partners to
                                  analyze device activities and generate targeted advertisements.
                                </p>
                              </li>
                              <li>
                                <p class="" style="white-space: pre-wrap">
                                  We may transfer your personal information to another company in connection with a
                                  proposed merger, sale, acquisition or other change of ownership or control by or of
                                  TGC (whether in whole or in part). We will make reasonable efforts to notify you
                                  before your information becomes subject to different privacy practices.
                                </p>
                              </li>
                              <li>
                                <p class="" style="white-space: pre-wrap">
                                  We also may need to disclose your personal information or any other information we
                                  collect about you if we determine in good faith that such disclosure is needed to:
                                  (1)&nbsp;comply with or fulfill our obligations under applicable law; (2)&nbsp;protect
                                  the rights, property or safety of you, TGC or another party; (3)&nbsp;enforce this
                                  Privacy Policy or other agreements with you; or (4)&nbsp;respond to claims that any
                                  posting or other content violates third-party rights.
                                </p>
                              </li>
                            </ul>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p class="" style="white-space: pre-wrap">
                              <strong>7.&nbsp;Collection and Use of Sensitive Information</strong
                              ><span style="text-decoration: underline"><strong> </strong></span>
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              We have collected the following categories of sensitive personal information from
                              consumers within the last twelve months:
                            </p>
                            <ul data-rte-list="default">
                              <li><p class="" style="white-space: pre-wrap">Government identifiers</p></li>
                              <li><p class="" style="white-space: pre-wrap">Complete account credentials</p></li>
                              <li><p class="" style="white-space: pre-wrap">Racial or ethnic origin</p></li>
                              <li><p class="" style="white-space: pre-wrap">Religious or philosophical beliefs</p></li>
                              <li><p class="" style="white-space: pre-wrap">Union membership</p></li>
                              <li><p class="" style="white-space: pre-wrap">Genetic data</p></li>
                              <li>
                                <p class="" style="white-space: pre-wrap">Mail, email, or text message contents</p>
                              </li>
                              <li>
                                <p class="" style="white-space: pre-wrap">Unique identifying biometric information</p>
                              </li>
                              <li>
                                <p class="" style="white-space: pre-wrap">Health, sex life, or sexual orientation</p>
                              </li>
                              <li><p class="" style="white-space: pre-wrap">Citizenship</p></li>
                              <li><p class="" style="white-space: pre-wrap">Immigration status</p></li>
                            </ul>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              We do not use or disclose sensitive personal information for purposes other than those
                              specified in the CCPA/CPRA.
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              <strong>8. Storage and Security of Information</strong>
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              Any information you send to us electronically, while using the TGC Services or otherwise
                              interacting with us, may not be secure when it is transmitted to us. We recommend that you
                              do not use unsecure channels to communicate sensitive or confidential information to us.
                              Please be aware, despite our best efforts, no security measures are perfect or
                              impenetrable, and we cannot guarantee “perfect security.” Any information you send us
                              through any means is transmitted at your own risk.
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              <strong>9.&nbsp;Your Choices</strong>
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              <strong>9.1 Information You Provide</strong>&nbsp;
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              You can choose whether or not to provide personal information through the TGC Services. We
                              will not discriminate against you for exercising any of your rights relating to your
                              personal information and will not (i) deny you goods or services, (ii) provide you with a
                              different level or quality of services, or (iii) charge you different prices for services
                              for doing so.
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              <strong>9.2 California Privacy Rights</strong>
                            </p>
                            <p class="" data-rte-preserve-empty="true" style="white-space: pre-wrap"></p>
                            <p class="" style="white-space: pre-wrap">
                              In the preceding 12 months, we collected and disclosed for a business purpose the
                              following categories of personal information about California consumers:
                            </p>
                            <p class="" data-rte-preserve-empty="true" style="white-space: pre-wrap"></p>
                            <p class="" style="white-space: pre-wrap"><strong>Category</strong></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              <strong>Examples</strong>
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              <strong>Collected?</strong>
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              <strong>Categories of Recipients</strong>
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              Identifiers
                            </p>
                            <p class="" style="white-space: pre-wrap">Name, address, e-mail address, IP address</p>
                            <p class="" style="white-space: pre-wrap">Yes</p>
                            <p class="" style="white-space: pre-wrap">i.e., Organizations providing services to TGC</p>
                            <p class="" style="white-space: pre-wrap">
                              Personal information categories listed in the California Customer Records statute
                            </p>
                            <p class="" style="white-space: pre-wrap">
                              Name, professional-related information; and employment-related information
                            </p>
                            <p class="" style="white-space: pre-wrap">Yes</p>
                            <p class="" style="white-space: pre-wrap">i.e., Organizations providing services to TGC</p>
                            <p class="" style="white-space: pre-wrap">
                              Protected classification characteristics under California or federal law
                            </p>
                            <p class="" style="white-space: pre-wrap">
                              Name, age, citizenship, nationality, ancestry, religion or creed, marital status, medical
                              condition, physical or mental disability, sex (including gender, gender identity, gender
                              expression, pregnancy or childbirth and related medical conditions), sexual orientation,
                              veteran or military status, proof of eligibility to work
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              Yes
                            </p>
                            <p class="" style="white-space: pre-wrap">i.e., Organizations providing services to TGC</p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              Commercial information
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              Records of personal property, products or services purchased, obtained, or considered, or
                              other purchasing or consuming histories or tendencies.
                            </p>
                            <p class="" style="white-space: pre-wrap">Yes</p>
                            <p class="" style="white-space: pre-wrap">i.e., Organizations providing services to TGC</p>
                            <p class="" style="white-space: pre-wrap">Internet or other similar network activity</p>
                            <p class="" style="white-space: pre-wrap">
                              Browsing history, search history, information on a consumer’s interaction with the TGC
                              Services
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              Yes
                            </p>
                            <p class="" style="white-space: pre-wrap">i.e., Organizations providing services to TGC</p>
                            <p class="" style="white-space: pre-wrap">Geolocation data</p>
                            <p class="" style="white-space: pre-wrap">Location and movement data</p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              Yes
                            </p>
                            <p class="" style="white-space: pre-wrap">i.e., Organizations providing services to TGC</p>
                            <p class="" style="white-space: pre-wrap">Professional or employment-related information</p>
                            <p class="" style="white-space: pre-wrap">
                              Proof of eligibility to work, resumé, other professional-related information and
                              employment-related information
                            </p>
                            <p class="" style="white-space: pre-wrap">Yes</p>
                            <p class="" style="white-space: pre-wrap">i.e., Organizations providing services to TGC</p>
                            <p class="" style="white-space: pre-wrap">Biometric information</p>
                            <p class="" style="white-space: pre-wrap">
                              Genetic, physiological, behavioral, and biological characteristics, or activity patterns
                              used to extract a template or other identifier or identifying information, such as,
                              fingerprints, faceprints, and voiceprints, iris or retina scans, keystroke, gait, or other
                              physical patterns, and sleep, health, or exercise data.
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              Yes
                            </p>
                            <p class="" style="white-space: pre-wrap">i.e., Organizations providing services to TGC</p>
                            <p class="" style="white-space: pre-wrap">Non-Public Education Information</p>
                            <p class="" style="white-space: pre-wrap">
                              Education records directly related to a student maintained by an educational institution
                              or party acting on its behalf, such as grades, transcripts, class lists, student
                              schedules, student identification codes, student financial information, or student
                              disciplinary records
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              Yes
                            </p>
                            <p class="" style="white-space: pre-wrap">i.e., Organizations providing services to TGC</p>
                            <p class="" style="white-space: pre-wrap">Inferences from the foregoing</p>
                            <p class="" style="white-space: pre-wrap">
                              Profile reflecting a person's preferences, characteristics, psychological trends,
                              predispositions, behavior, attitudes, intelligence, abilities, and aptitudes.
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              Yes
                            </p>
                            <p class="" style="white-space: pre-wrap">i.e., Organizations providing services to TGC</p>
                            <p class="" data-rte-preserve-empty="true" style="white-space: pre-wrap"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              <strong>Purposes for Collection, Use, and Sharing</strong>. We use and disclose the
                              personal information we collect for our commercial purposes, as further described in this
                              Privacy Policy, including for our business purposes with our partners and service
                              providers as follows:
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <ul data-rte-list="default">
                              <li>
                                <p class="" style="white-space: pre-wrap">
                                  Legal compliance and auditing related to our interactions with you.
                                </p>
                              </li>
                              <li>
                                <p class="" style="white-space: pre-wrap">
                                  Detecting security incidents, protecting against malicious, deceptive, fraudulent, or
                                  illegal activity, and exercising our related rights.
                                </p>
                              </li>
                              <li>
                                <p class="" style="white-space: pre-wrap">
                                  Performing and improving out services (by us or our service provider(s)).
                                </p>
                              </li>
                              <li><p class="" style="white-space: pre-wrap">Internal operations.</p></li>
                              <li><p class="" style="white-space: pre-wrap">Other one-time or short-term uses.</p></li>
                            </ul>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              <strong>Your Rights</strong>. If you are a California resident you may have the following
                              rights under the CCPA/CPRA in relation to personal information we have collected about
                              you, to the extent required by the CCPA/CPRA and subject to verification:
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              <span style="text-decoration: underline">Right to Know/Access</span>: You have the right
                              to request certain information about our collection and use of personal information about
                              you as described below:
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <ul data-rte-list="default">
                              <li>
                                <p class="" style="white-space: pre-wrap">
                                  The specific pieces of your personal information collected.
                                </p>
                              </li>
                              <li>
                                <p class="" style="white-space: pre-wrap">
                                  The categories of your personal information collected.
                                </p>
                              </li>
                              <li>
                                <p class="" style="white-space: pre-wrap">
                                  The categories of sources from whom your personal information is collected.
                                </p>
                              </li>
                              <li>
                                <p class="" style="white-space: pre-wrap">
                                  The purpose for collecting your personal information.
                                </p>
                              </li>
                              <li>
                                <p class="" style="white-space: pre-wrap">
                                  The categories of third parties with whom we have shared your personal information.
                                </p>
                              </li>
                            </ul>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              <span style="text-decoration: underline">Right to Delete</span>: You have the right to
                              request that we delete certain personal information we have about you.
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              <span style="text-decoration: underline">Freedom from Discrimination</span>: You have the
                              right to be free from unlawful discrimination for exercising any of your privacy rights.
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              <span style="text-decoration: underline">Right to Correct</span>: You have the right to
                              request that we correct inaccurate personal information regarding the information you
                              provide us.
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              <span style="text-decoration: underline"
                                >Right to Restrict the Use of Sensitive Personal Information</span
                              >: You have the right to restrict the use of your sensitive personal information.
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              <span style="text-decoration: underline"
                                >Right to Access Information on Automated Decision-Making</span
                              >: You have the right to access information collected through automated decision-making.
                              Additionally, you can opt-out of our use of automated decision-making related to your
                              personal information.
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              To make a request in relation to the above rights, please contact us using the information
                              in Section 14 below. To fulfil your request, we will need to verify your identity. Only
                              you or someone legally authorized to act on your behalf may make a request related to your
                              personal information. To designate an authorized agent, the authorized agent must provide
                              sufficient information that allows us to reasonably verify that you authorize them to act
                              on your behalf.
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              <strong>9.3 Canada, European Union and United Kingdom Privacy Rights</strong>
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              If our processing of your personal information is subject to GDPR, UK GDPR, and/or PIPEDA,
                              and unless subject to an exemption, you may have the following rights with respect to your
                              personal information:
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              <span style="text-decoration: underline">Right of Access</span>: You have the right to
                              view and request copies of your personal information.
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              <span style="text-decoration: underline">Right to Rectification</span>: You have the right
                              to request that your inaccurate or outdated personal information be updated or corrected.
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              <span style="text-decoration: underline">Right to be Forgotten/Right to Erasure</span>:
                              You have the right to request your personal data be deleted, upon providing verification
                              to us.
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              <span style="text-decoration: underline">Right to Restrict Processing</span>: You have the
                              right to request the restriction or suppression of our processing of your personal
                              information.
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              <span style="text-decoration: underline">Right to be Informed</span>: You have the right
                              to be informed about the collection and use of your personal information.
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              <span style="text-decoration: underline">Right to Data Portability</span>: You have the
                              right to ask for your personal information to be transferred to you or to another
                              controller.
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""></p>
                            <p class="" style="white-space: pre-wrap">
                              <span style="text-decoration: underline">Right to Withdraw Consent</span>: You have the
                              right to withdraw previously given consent to process your personal information.
                            </p>
                            <p class="" data-rte-preserve-empty="true" style="white-space: pre-wrap"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              <span style="text-decoration: underline">Right to Object</span>: You have the right to
                              object to the processing of your personal information.
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              <span style="text-decoration: underline">Right to Object to Automated Processing</span>:
                              You have the right to object to decisions being made with your personal information solely
                              based on automated decision making or profiling.
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              We will need to verify your identity to process any requests described in this Section and
                              may deny your request if we are unable to verify your identity. Government or other
                              identification may be required.
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              If you are a resident of the European Economic Area (“<span
                                style="text-decoration: underline"
                                >EEA</span
                              >”), when we process your personal information, we will only do so in the following
                              situations:
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <ul data-rte-list="default">
                              <li>
                                <p class="" style="white-space: pre-wrap">
                                  We need to use your information to perform our responsibilities under our agreement
                                  with you.
                                </p>
                              </li>
                              <li>
                                <p class="" style="white-space: pre-wrap">
                                  We have a legitimate interest in processing your personal information. For example, we
                                  may process your personal information to send you marketing communications, to
                                  communicate with you about the TGC Services, and to provide and improve the TGC
                                  Services.
                                </p>
                              </li>
                              <li><p class="" style="white-space: pre-wrap">We have your consent to do so.</p></li>
                            </ul>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              If your personal data is subject to GDPR or UK GDPR, we will transfer personal data from
                              the EEA to a location outside the EEA only when there has been a documented adequacy
                              determination, or where we have confirmed adequate privacy protections. If your personal
                              data is subject to PIPEDA, we will transfer personal data from Canada to locations outside
                              Canada only where we have confirmed adequate privacy protections. If we transfer personal
                              data to a third party acting as our agent, we will also obligate the third party to have
                              adequate privacy protections in place.
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              <strong>10.&nbsp;How Long We Retain Your Information</strong>
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              We retain personal information about you for as long as necessary to provide you the TGC
                              Services. In some cases, we retain personal information for longer, if doing so is
                              necessary to comply with our legal obligations, or as otherwise permitted by applicable
                              law. Afterwards, we retain some information in a de-identified and/or aggregated form but
                              not in a way that would identify you personally.
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              <strong>11.&nbsp;Information Provided on Behalf of Children and Others</strong>
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              The TGC Services are not intended for use by children. Individuals under the age of 18 may
                              not use the TGC Services. TGC does not knowingly collect any information from children. If
                              you are under 18, do not attempt to register for the TGC Services or send us any personal
                              information. By accessing, using and/or submitting information through the TGC Services,
                              you represent that you are not younger than 18 and that you have authority to do so. If
                              you are a parent or legal guardian of a minor child, you may, in compliance with this
                              Privacy Policy, use the TGC Services on behalf of such minor child. Information you
                              provide through the TGC Services on behalf of a minor child will be treated as personal
                              information as provided herein. If you use the TGC Services on behalf of another person,
                              regardless of age, you represent and warrant that you have authority to do so.
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              <strong>12.&nbsp;Third Party Web Services</strong>
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              The TGC Services may contain links or content from third party websites. A link or content
                              from a third-party website does not mean we endorse that website, the accuracy of
                              information presented, or the persons or entities associated with that website. If you
                              visit a third-party website, you are subject to the privacy policy of the applicable third
                              party and we are not responsible for the policies and/or practices of any third party. We
                              encourage you to ask questions before you disclose your information to others.
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              <strong>13.&nbsp;Updates and Changes to Privacy Policy</strong>
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              The effective date of this Privacy Policy is set forth at the top of this webpage. We will
                              notify you of any material change by posting notice on this webpage. Your continued use of
                              the TGC Services after the effective date of any amendment to this Privacy Policy
                              constitutes your acceptance of the amended Privacy Policy. We encourage you to
                              periodically review this page for the latest information on our privacy practices. Any
                              amended Privacy Policy supersedes all previous versions. IF YOU DO NOT AGREE TO FUTURE
                              CHANGES TO THIS PRIVACY POLICY, YOU MUST STOP USING THE TGC SERVICES AFTER THE EFFECTIVE
                              DATE OF SUCH CHANGES.
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              <strong>14.&nbsp;Contact Us</strong>
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              The data controller for the purposes of GDPR, UK GDPR, PIPEDA or other data protection
                              laws is TGC. If you have any questions about this Privacy Policy, please contact us at
                              contact@brokenshepherds.com or at:
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class=""
                              data-rte-preserve-empty="true"></p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              <strong>Name</strong>
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              Attn: Executive Team
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              Address: 104 E 600 S C823
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              Heber City UT 84032
                            </p>
                            <p
                              style="text-align: justify; white-space: normal !important; white-space: pre-wrap"
                              class="">
                              Email: contact@brokenshepherds.com
                            </p>
                            <p class="" data-rte-preserve-empty="true" style="white-space: pre-wrap"></p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </article>
      </main>
    </div>
  </body>
</html>
`;
